import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, BookingCalendar, SelectControl, Loading } from "wup-module1-base";
import { ModalText } from "../../Components";
import { LocalizationSelect } from "../Form";
import { faRightLong, faLeftLong } from "@fortawesome/free-solid-svg-icons";
import { TYPE_OF_SERVICE } from "../../Constants";
import {
  faCircleRight,
  faCircleLeft,
  faCircleXmark,
  faCircleCheck,
} from "@fortawesome/free-regular-svg-icons";
import moment from "moment";
import { LocalizationService, MeetingService } from "../../Services";

const BoxOffers = (data) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingSelection, setIsSubmittingSelection] = useState(false);
  const [showHourSelection, setShowHourSelection] = useState(false);
  const [descriptionIsOpen, setOpenDescription] = useState(false);
  const [localizationIsOpen, setLocalizationIsOpen] = useState(false);
  const [calendarIsOpen, setOpenCalendar] = useState(false);
  const [noAvailableDates, setNoAvailableDates] = useState(false);
  const [meetings, setMeetings] = useState([]);
  const [listOfMeeting, setListOfMetting] = useState([]);
  const [dateShow, setDateShow] = useState(false);
  const [isSelectedMeetingRemote, setIsSelectedMeetingRemote] = useState(false);
  const [localizationWasSelected, setLocalizationWasSelected] = useState(false);
  const [listOfEvent, setListOfEvent] = useState(false);
  const [selectedMeeting, setSelectedMetting] = useState();
  const [selectedHour, setSelectedHour] = useState();
  const [selectedLocalization, setSelectedLocalization] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [description, setDescription] = useState(false);
  const [length, setLength] = useState(0);
  const [isJSON, setIsJSON] = useState(false);
  const [showConfirm, setShowConfirm] = useState(true);
  const calendarRef = useRef(null);

  let [current, setCurrent] = useState(0);
  let image = { backgroundImage: `url(${data.image})` };
  let background_image = { backgroundImage: `url(${data.background_image})` };

  const setDataForCalendar = (arg) => {
    setDateShow(false);
    setIsSubmittingSelection(true);

    if (!calendarRef.current) {
      return;
    }

    const currentDateFormatted = moment(arg.date).format("YYYY-MM-DD");
    const dateFormatted = moment(arg.date).format("DD.MM.YYYY");
    setSelectedDate(dateFormatted);

    const meetingsInSelectedDate = meetings.filter((meeting) => {
      return meeting.date_from.startsWith(currentDateFormatted);
    });

    if (meetingsInSelectedDate.length === 0) {
      setShowHourSelection(false);
      setIsSubmittingSelection(false);
      setListOfMetting([]);
      return;
    }

    const listOfMeeting = [{ name: "", value: 0 }];
    meetingsInSelectedDate.forEach((meeting) => {
      const startDate = new Date(meeting.date_from);
      const endDate = new Date(meeting.date_to);

      listOfMeeting.push({
        name: `od: ${startDate.toLocaleTimeString().slice(0, 5)} do ${endDate.toLocaleTimeString().slice(0, 5)}`,
        value: meeting.id,
      });
    });

    setSelectedMetting(listOfMeeting[0].value);
    setSelectedHour(listOfMeeting[0].name);
    setListOfMetting(listOfMeeting);
    setShowHourSelection(true);
    setIsSubmittingSelection(false);
  };

  const goPrevious = () => {
    if (current > 0) {
      setCurrent(current - 1);
    } else {
      setCurrent(length - 1);
    }
  };

  const goNext = () => {
    if (current == length - 1) {
      setCurrent(0);
    } else {
      setCurrent(current + 1);
    }
  };

  const clearState = () => {
    setLocalizationWasSelected(false);
    setSelectedLocalization(null);
    setShowHourSelection(false);
    setSelectedDate(null);
    setSelectedHour(null);
    setShowConfirm(false);
    setOpenDescription(false);
  }

  const handleCloseCalendarModal = () => {
    setLocalizationWasSelected(false);
    setSelectedLocalization(null);
    setOpenCalendar(false);
    setShowConfirm(false);
  };

  const handleCloseDescriptionModal = () => {
    setOpenDescription(false);
  };

  const handleHideLocalizationModal = () => {
    setSelectedLocalization(null);
    setLocalizationIsOpen(false);
    setShowConfirm(false);
  };

  const handleConfirmLocalizationModal = () => {
    setLocalizationWasSelected(true);
    handleHideLocalizationModal();
    openCalendarModal();
  }

  const handleHideDescriptionModal = () => {
    setOpenDescription(false);
  };

  const handleSelectOffer = () => {
    console.log(data);
    handleHideDescriptionModal(); 
    localizationWasSelected ? openCalendarModal() : setLocalizationIsOpen(true);
  };

  const handleUnselectOffer = () => {
    clearState();

    data.changeMethod(data.index, data.id);
  };

  function openDescriptionModal() {
    try {
      let descriptions = JSON.parse(data.description);
      setIsJSON(true);
      setDescription(descriptions);
      setLength(descriptions.length);
    } catch (e) {
      setIsJSON(false);
      setDescription(data.description);
      setLength(1);
    }

    setOpenDescription(true);
  }

  function setMetting(id) {
    if (id !== null) {
      let hourValue = listOfMeeting.find((item) => item.value == id);
      setSelectedHour(hourValue.name);
      setDateShow(true);
      setSelectedMetting(id);
      setShowConfirm(true);
      return;
    }

    setDateShow(false);
    setShowConfirm(false);
  }
  function confirmMetting() {
    data.changeMethod(data.index, data.id);
    data.changeBooking(selectedMeeting);
    setOpenCalendar(false);
    handleCloseDescriptionModal();
  }

  function openCalendarModal() {
    setIsSubmitting(true);
    const events = [];
    const exclusiveSerivceTypeFilter = { key: "exclusive_service_type", value: data.id };
    const serviceTypeFilter = { key: "service_type", value: TYPE_OF_SERVICE.EXCLUSIVE.id };
    const onlyFutureTypeFilter = { key: "only_future", value: 1 };
    const onlyNotFulfilled = { key: "fulfield", value: 0 };

    const filters = [exclusiveSerivceTypeFilter, serviceTypeFilter, onlyFutureTypeFilter, onlyNotFulfilled];
    LocalizationService.getMeetings(selectedLocalization, filters).then((response) => {
      response.data.forEach((item) => {
        const date = moment(item.date_from).format("YYYY-MM-DD");

        if (!events.some((event) => moment(event.start).format("YYYY-MM-DD") === date)) {
          events.push({
            title: "",
            start: date,
            display: "background",
            color: "green",
          });
        }
      });

      setNoAvailableDates(response.data === null || response.data.length === 0);
      setMeetings(response.data);
      setListOfEvent(events);
    }).catch((error) => {
      setNoAvailableDates(true);
      console.error(error);
    }).finally(() => {
      setIsSubmitting(false);
    });

    setOpenCalendar(true);
  }

  return (
    <>
      <div className="offer-box-1">
        <div
          id={`${data.pictureId}`}
          className="offer-1"
          style={image}
          title={data.photo_name}
          onClick={openDescriptionModal}
        >
          <div
            id={`${data.offerId}`}
            onClick={openDescriptionModal}
            className="offer-text-1"
          >
            <div className="offer-text">{data.name}</div>
            <div className="offer-text-more">
              <span>Kliknij i dowiedz się więcej...</span>
            </div>
          </div>
        </div>
        <div className="offer-button">
          {data.type === data.id ? (
            <button className="button-confirm-modal" onClick={handleUnselectOffer}>
              <span className="accept-cancel-button-active">
                <span className="accept-cancel-button-text">
                  Kliknij, aby anulować
                </span>
                <FontAwesomeIcon
                  icon={faCircleLeft}
                  className="accept-cancel-button-icon"
                />
              </span>
            </button>
          ) : (
            <button className="button-confirm-modal" onClick={handleSelectOffer}>
              <span className="accept-cancel-button">
                <FontAwesomeIcon
                  icon={faCircleRight}
                  className="accept-cancel-button-icon"
                />
                <span className="accept-cancel-button-text">
                  Kliknij, aby wybrać
                </span>
              </span>
            </button>
          )}
        </div>
      </div>

      <Modal
        show={descriptionIsOpen}
        size={"xl"}
        enforceFocus={true}
        onClose={handleHideDescriptionModal}
        className="offer-modal-body"
      >
        <div className="offer-modal left-right" style={background_image}>
          <div
            className="float-right mr-1 mt-1"
            type="button"
            variant="primary"
            onClick={handleCloseDescriptionModal}
          >
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="accept-cancel-button-icon"
            />
          </div>

          <ModalText
            title={data.name}
            icon={data.icon}
            description={description}
            current={current}
            isJSON={isJSON}
          />
          <div className="centered-bottom">
            <div className="button-box-modal"></div>
            {!!isJSON && (
              <div type="button" variant="primary" onClick={goPrevious}>
                <FontAwesomeIcon icon={faLeftLong} className="accept-arrow-button-icon" />
              </div>
            )}
            {data.type === data.id ? (
              <button className="button-confirm-modal" onClick={handleUnselectOffer}>
                <span className="accept-cancel-button-active">
                  <span className="accept-cancel-button-text">Anuluj</span>
                </span>
              </button>
            ) : (
              <button className="button-confirm-modal" onClick={handleSelectOffer}>
                <span className="accept-cancel-button">
                  <span className="accept-cancel-button-text">Wybieram</span>
                </span>
              </button>
            )}
            {isJSON && (
              <div type="button" variant="primary" onClick={goNext}>
                <FontAwesomeIcon
                  icon={faRightLong}
                  className="accept-arrow-button-icon"
                />
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        className="calendar-modal"
        show={localizationIsOpen}
        title={"Zaznacz lokalizację"}
        onCancel={handleHideLocalizationModal}
        onConfirm={handleConfirmLocalizationModal}>
        <LocalizationSelect setValue={setSelectedLocalization} setIsRemote={setIsSelectedMeetingRemote} value={selectedLocalization} />
      </Modal>

      <Modal
        className="calendar-modal"
        show={calendarIsOpen && localizationWasSelected}
        size={"default"}
        title={"Zarezerwuj spotkanie"}
        enforceFocus={true}
        onClose={handleCloseCalendarModal}
      >
        {isSelectedMeetingRemote && data.only_stationary ? (
          <p>Warsztaty dostępne tylko w formie stacjonarnej.</p>
        ) : (
          isSubmitting ? (
            <Loading size="lg" className="px-10" variant="dark" />
          ) : (
            <>
              {meetings.length === 0 ? (
                <>
                  <h2>Brak wolnych terminów</h2>
                  <p>
                    Skontaktuj sie z administracją
                  </p>
                </>
              ) : (
                <>
                  <h5 className="text-color">Wskaż Termin spotkania</h5>
                  <BookingCalendar
                    calendarRef={calendarRef}
                    onDateChange={setDataForCalendar}
                    events={listOfEvent}
                  />
                  {showHourSelection ? (
                    <>
                      {isSubmittingSelection ? (
                        <Loading
                          size="lg"
                          className="px-10"
                          variant="dark"
                          style={{ marginTop: "20px" }}
                        />
                      ) : (
                        <>
                          <br />
                          <div className="centered">
                            <h6 className="text-color-time-1">
                              Wybierz godzinę:
                            </h6>
                            <SelectControl
                              options={listOfMeeting}
                              onChange={setMetting}
                            />
                          </div>
                          {dateShow && (
                            <div className="centered">
                              <h6 className="text-color-time-2">
                                Wybrano termin:{" "}
                              </h6>
                              <div>
                                {selectedDate} {selectedHour}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {isSubmittingSelection ? (
                        <div className="centered">
                          <Loading size="lg" className="px-10" variant="dark" />
                        </div>
                      ) : noAvailableDates ? (
                        <div className="centered">
                          <h2>Brak wolnych terminów</h2>
                        </div>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </>
          )
        )}

        {showConfirm && (
          <div
            type="button"
            variant="primary"
            className="float-right"
            onClick={confirmMetting}
          >
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="accept-cancel-button-icon"
            />
          </div>
        )}

        <div
          type="button"
          variant="primary"
          className="left-right"
          onClick={handleCloseCalendarModal}
        >
          <FontAwesomeIcon icon={faCircleXmark} className="accept-cancel-button-icon" />
        </div>
      </Modal>
    </>
  );
};

export default BoxOffers;
